import { useEffect, useState } from 'react'
import {Loader, Subsription,Modal} from "../components"
import config from '../config'
import axios from 'axios'
import { decode } from 'base-64'
import { SubscriptionResponseText as text } from '../database/SubscriptionText'
import { useMainContext } from '../callContext/MainContext'
import { useNavigate,useSearchParams } from 'react-router-dom'
import { logEvent } from '../analytics/AnalyticsEvent'
import { useCallContext } from '../callContext/callContext'
import { isFacebookCampaign } from '../utils/Helpers'
import {SendGuiDataEvents} from "../commonScript"

const SubsriptionPacks = () => {
    const {language,selectedPack,setSelectedPack}=useMainContext();
    const {showModal,setShowModal}=useCallContext();
    const [loading,setLoading]=useState(true);
    const [message,setMessage]=useState("")
    const navigate=useNavigate();
    const [showPacks,setShowPacks]=useState(true)
    const [msisdn,setMsisdn]=useState(localStorage.getItem("msisdn") || "");
    const [searchParams]=useSearchParams();
    const p=searchParams.get("p");
    const isPromotionalURL=localStorage.getItem("campId") && localStorage.getItem("rcid");
    console.log("p is::",p)
    const hasHeRequestDone = localStorage.getItem('hasHeRequestDone');

    useEffect(()=>{
    let guiPlayEvents = {};
    guiPlayEvents["w_action"] = "packspage";
    SendGuiDataEvents(guiPlayEvents);
    },[])
    useEffect(() => {
      const handleRedirect = () => {
        if (!msisdn && !hasHeRequestDone) {
          localStorage.setItem('hasHeRequestDone', 'true');
          let newHeUrl=config.get('heUrl');
        let sid=localStorage.getItem("sessionId");
        let camp=localStorage.getItem("campId") || sessionStorage.getItem("campId");
        let rcid=localStorage.getItem("rcid") || sessionStorage.getItem("rcid");
        if(sid)
        {
           newHeUrl=newHeUrl+"?sid="+sid;
        }
        if(rcid)
        {
           newHeUrl=newHeUrl+'&rcid='+rcid
        }
        if(camp)
        {
           newHeUrl=newHeUrl+'&camp='+camp;
        }
        if(isFacebookCampaign())
        {
           newHeUrl=newHeUrl+(newHeUrl.includes('?')?'&':'?')+'campaign=fb';
        }
         console.log("HeUrl::",newHeUrl)
         let guiDataEvent = {};
         guiDataEvent['w_action'] = "he_redirection";
         guiDataEvent['w_redirecturl'] = newHeUrl;
         SendGuiDataEvents(guiDataEvent);
         setTimeout(() => {
          window.open(newHeUrl, '_self');
        }, 1000);
        } else if (p && hasHeRequestDone) {
          const decodeValue = JSON.parse(decode(p));
          if (decodeValue.status === 'success') {
            setMsisdn(decodeValue.msisdn);
            localStorage.setItem('msisdn', decodeValue.msisdn);
            if(decodeValue?.is_blocked===1)
            {
               console.log("user is not authorized")
               setLoading(false);
               navigate("/not-allowed");
            }
            //facebook campaign users are always active, skip checkSub
            else if (isFacebookCampaign())
            {
              navigate("/home", { replace: true });
            }
            else
            {
              checkSub(decodeValue.msisdn || msisdn);
            }
          } else if (decodeValue.status === 'failed') {
            if (isFacebookCampaign()) {
              navigate("/home", { replace: true });
            } else {
              setShowPacks(false);
              setLoading(false);
            }
          }
        } else if (isFacebookCampaign()) {
          //facebook campaign users are always active, skip checkSub
          navigate("/home", { replace: true });
        } else if (msisdn) {
          checkSub(msisdn);
        } else {
          setLoading(false);
        }
      };
  
      handleRedirect();
    }, []);
  
    const handleRetryClick=()=>
      {
        let newHeUrl=config.get('heUrl');
        let sid=localStorage.getItem("sessionId");
        let camp=localStorage.getItem("campId");
        let rcid=localStorage.getItem("rcid");
        if(sid)
        {
           newHeUrl=newHeUrl+"?sid="+sid;
        }
        if(rcid)
        {
           newHeUrl=newHeUrl+'&rcid='+rcid
        }
        if(camp)
        {
           newHeUrl=newHeUrl+'&camp='+camp;
        }
        if(isFacebookCampaign())
        {
           newHeUrl=newHeUrl+(newHeUrl.includes('?')?'&':'?')+'campaign=fb';
        }
        console.log("HeUrl::",newHeUrl)
        let guiDataEvent = {};
        guiDataEvent['w_action'] = "he_redirection";
        guiDataEvent['w_redirecturl'] = newHeUrl;
        SendGuiDataEvents(guiDataEvent);
        window.open(newHeUrl, '_self');
      }
 
    const checkSub = async (num) => {
      if (num && (num!=='undefined' || num!==undefined)) {
        logEvent(
          {
            screen: "packs",
            event: "sub_api_request",
          },
          {
            title: "sub_api_request",
            userId: msisdn ? num : "NA",
            others: {
              date: new Date(),
            },
          }
        );
        setLoading(true)
        const url = `${config.get("base")}${config.get("checkSub")}`;
        console.log("headers are::",config.get('headers'))
        const headers=
        {
          ...config.get('headers'),
          Language:language,
          camp : sessionStorage.getItem("campId"),
          rcid : sessionStorage.getItem("rcid")
        };
        await axios
          .post(url, { msisdn: num }, {headers:headers})
          .then((result) => {
            console.log("checkSub api :::", result);
            localStorage.setItem("displayStatus", result?.data?.status_display);
            localStorage.setItem("subStatus", result?.data?.subStatus);
            localStorage.setItem("uid", result?.data?.uid);
            localStorage.setItem("validity", result?.data?.validity);
            logEvent(
              {
                screen: "home",
                event: "sub_api_response",
              },
              {
                title: "sub_api_response",
                userId: msisdn ? msisdn : "NA",
                others: {
                  status: result?.data?.subStatus,
                  date: new Date(),
                },
              }
            )
            setLoading(false);

            if(result?.data?.status?.toLowerCase()==="success")
              {
            if(result?.data?.subStatus?.toLowerCase()==="active")
              {
                navigate("/home")
              }
            
            else if(result?.data?.subStatus?.toLowerCase()==="grace")
            {
                setMessage(result?.data?.message)
                setShowModal(true);
            }
            else
            {
              setShowPacks(true);
              if(result?.data?.subStatus?.toLowerCase()==='new')
                {
                  localStorage.setItem("initialState", result?.data?.subStatus);
                }
              navigate("/subs/packs");
            }
          }
          else 
          {
            console.log("Status got failed")
            // setMessage(result?.data?.message);
            // setShowModal(true)
            setShowPacks(false)
          }
          })
          .catch((error) => {
            console.log(error);
          });
       
      } else {
        console.log("No uid is present");
        navigate("/subs/packs");
      }
    };
  if(loading) return <Loader/>;
  return (
   <Subsription>
         <p className='p-4'>{text?.subPackText?.[language]}</p>
         {showPacks && msisdn && (msisdn!=='undefined' || msisdn!==undefined )?
         <>
        <p className='px-4 pb-4 tracking-wider'>{text?.modalText?.[language]}</p>
        <div className='flex flex-row justify-center items-center gap-2 py-3 w-full flex-wrap'>
         {text?.packsText?.map((pack, index) => {
          if(isPromotionalURL && (index==1 || index==2))
            {
              return null;
            }  
             return (
                 <div key={pack?.id} className={`border-2 cursor-pointer border-white relative w-[30%] h-28 ${selectedPack?.id===pack.id?'bg-white':null}`} style={{minHeight:"4rem"}} 
                     onClick={(e)=>
                      {
                         e.stopPropagation();  
                        let isNewSelection = selectedPack?.id !== pack.id;
                        if (isNewSelection) {
                          let guiDataEvent = {};
                          guiDataEvent['w_action'] = "pack_click";
                          guiDataEvent['pack_type'] = pack.packType;
                          SendGuiDataEvents(guiDataEvent);
                          localStorage.setItem("selectedPack",JSON.stringify(pack));
                          localStorage.setItem("modalType",'confirm')
                          setSelectedPack(pack);
                        }
                        if ((selectedPack?.id === pack.id || isNewSelection) && msisdn && (msisdn!=='undefined' || msisdn!==undefined )) {
                          let confirmGuiDataEvent = {};
                          confirmGuiDataEvent['w_action'] = "confirm_click";
                          confirmGuiDataEvent['pack_type'] = pack.packType;
                          SendGuiDataEvents(confirmGuiDataEvent);
                          navigate("/subs/modal");
                        }
                      }
                     }> 
                    <h1 className='text-base bg-red-500 text-white p-1'>{pack?.packTitle?.[language]}</h1>
                    <p className='text-base py-4 '>{pack?.pricePointText?.[language]}</p>
                    <button
                className={`rounded-md text-sm  px-4 absolute font-bold text-white -translate-x-1/2 -bottom-2 ${selectedPack?.id===pack.id?'bg-red-500':'bg-red-400'}`}
                onClick={(e)=>{     
                   e.stopPropagation();         
                  if ((selectedPack?.id === pack.id) && msisdn && (msisdn!=='undefined' || msisdn!==undefined )) {
                    let guiDataEvent = {};
                    guiDataEvent['w_action'] = "confirm_click";
                    guiDataEvent['pack_type'] = pack.packType;
                    SendGuiDataEvents(guiDataEvent);
                    navigate("/subs/modal");
                  }
                }}
              >
                {text?.okButtonText?.[language]}
              </button>
           </div>
          )
           })}
         </div>
         </>:
         <>
             {!message ?
             <div>
               <h1 className='px-4 bold'>{text?.noMsisdnFoundText?.[language]}</h1>
               <button
                    type="submit"
                    className="bg-red-500 w-fit p-1 px-3 text-white mt-3 rounded-md text-center card-shadow font-bold"
                    onClick={handleRetryClick}
                  >
                    {text?.retryBtnText?.[language]}
                  </button>
              </div>
               :<h1 className='px-4 bold'>{message}</h1>
            }
          </>
          }
         {/* <button className={`p-2 rounded-full text-lg px-4 bg-red-600 my-3 font-bold w-fit m-auto text-white ${selectedPack?'opacity-100':'opacity-70'}`}
           onClick={console.log("no action")}>
        {text?.buttonText?.[language]}
      </button> */}
      {showModal && <Modal showModel={showModal} setShowModel={setShowModal} reason={message} setLoading={setLoading}/>}
   </Subsription>
  )
}

export default SubsriptionPacks